@if (!showFullList) {
  <div class="notifications-popup">
    <div class="popup-header">
      <span class="title">Notifications</span>
    </div>
    <div class="popup-close">
      <button class="close-btn" (click)="close()">
        <img src="assets/cancel.svg" alt="close" class="close-icon" />
      </button>
    </div>
    @if (hasUnreadNotifications) {
      <div class="mark-all-read">
        <a href="javascript:void(0)" (click)="onMarkAllAsRead()">Mark all as read</a>
      </div>
    }

    <div class="notifications-list">
      @if (isLoading) {
        <div class="notifications-skeleton" role="status" aria-label="Loading notifications">
          @for (row of skeletonRows; track row) {
            <div class="notification-item notification-item--skeleton">
              <div class="sk-block notification-item--skeleton__icon" aria-hidden="true"></div>
              <div class="notification-content">
                <span class="sk-block sk-text-md notification-item--skeleton__title" aria-hidden="true"></span>
                <div class="time-row">
                  <span class="sk-block sk-text-sm notification-item--skeleton__time" aria-hidden="true"></span>
                </div>
              </div>
            </div>
          }
        </div>
      } @else {
        @for (note of filteredNotifications; track note.id) {
          <div
            class="notification-item"
            [class.read]="note.read"
            [class.unread]="!note.read"
            (click)="onNotificationClick(note, $event)"
          >
            <div
              class="notification-icon"
              [ngClass]="{
                'tick-bg': note.type !== 'alerts' && note.type !== 'alert',
                'alert-bg': note.type === 'alerts' || note.type === 'alert',
              }"
            >
              @if (note.type !== 'alerts' && note.type !== 'alert') {
                <img src="assets/tick-icon.svg" alt="tick" class="tick-icon" />
              } @else {
                <img src="assets/Vector.svg" alt="alert" class="alert-icon" />
              }
            </div>
            <div class="notification-content">
              <p class="message">{{ note.title }}</p>
              <div class="time-row">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#9ca3af"
                  stroke-width="2"
                >
                  <circle cx="12" cy="12" r="9" />
                  <path d="M12 7v5l3 3" />
                </svg>
                <span class="time">{{ note.time }}</span>
              </div>
            </div>
            @if (!note.read) {
              <div class="unread-dot"></div>
            }
          </div>
        }
      }
    </div>

    <div class="popup-footer">
      <a href="javascript:void(0)" (click)="openFullList()">View all notifications</a>
    </div>
  </div>
} @else {
  <!-- Full notification list screen -->
  <div class="notification-full-list">
    <app-notifications-list [allNotifications]="allNotifications" (back)="closeFullList()">
    </app-notifications-list>
  </div>
}
